import { FC } from 'react';

interface LoadingPageProp {
    styles?: { [key: string]: string }
    extraClasses?: string
}

const LoadingPage: FC<LoadingPageProp> = ({ styles, extraClasses = "" }) => {
    return (
        <div className="fixed inset-0 z-[2000] grid place-items-center bg-white">
            <div
                className={`h-20 w-20 animate-spin rounded-full border-[6px] border-primary-100 border-t-primary-400 ${extraClasses}`}
                role="status"
                style={styles}
            >
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}

export default LoadingPage
